import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { useInstance } from 'intact-vue';
import { useState, watchState } from '../../hooks/useState';
import { getNowDate, last } from './helpers';
import { _$ } from '../../i18n';
import { PanelFlags } from './usePanel';
export function useShowDate(panel) {
  var instance = useInstance();
  var _instance$get = instance.get(),
    flag = _instance$get.flag,
    type = _instance$get.type;
  var date = getNowDate();
  if (flag === PanelFlags.End) {
    date = getPanelShowDate(date, true);
  }
  var showDate = useState(date);
  var anotherPanel = flag === PanelFlags.Start ? panel.endRef : panel.startRef;
  instance.on('$receive:value', function (v) {
    var lastValue = last(v);
    var value;
    if (Array.isArray(lastValue)) {
      if (lastValue.length !== 2) return;
      // range
      var _flag = instance.get('flag');
      value = lastValue[_flag];
    } else {
      value = lastValue;
    }
    var another;
    if (value && !value.isSame(showDate.value, 'month') && (
    // ignore if it is in another panel
    !(another = anotherPanel.value) || !value.isSame(another.showDate.date.value, 'month'))) {
      showDate.set(value);
    }
  });
  // ensure the start panel's date is before the end panel's
  watchState(showDate, function (v) {
    if (flag === PanelFlags.Start) {
      var endPanel = anotherPanel.value;
      if (endPanel) {
        var endShowDate = endPanel.showDate.date.value.date(1);
        if (v.isAfter(endShowDate, 'date') || v.isSame(endShowDate, 'date')) {
          // maybe we are changing the year, so we must set it as the next month from show date
          // of start panel
          // endPanel.showDate.nextMonth();
          endPanel.showDate.date.set(getPanelShowDate(v, true));
        }
      }
    } else {
      var startPanel = anotherPanel.value;
      if (startPanel) {
        // maybe changed to time picker
        var startShowDate = startPanel.showDate.date.value;
        // set to the last date
        startShowDate = startShowDate.add(1, 'month').add(-1, 'day');
        if (v.isBefore(startShowDate, 'date') || v.isSame(startShowDate, 'date')) {
          // startPanel.showDate.prevMonth();
          startPanel.showDate.date.set(getPanelShowDate(v, false));
        }
      }
    }
  });
  function getPanelShowDate(date, isEnd) {
    switch (type) {
      case 'year':
        return date.add(isEnd ? 10 : -10, 'year');
      case 'month':
        return date.add(isEnd ? 1 : -1, 'year');
        break;
      default:
        return date.add(isEnd ? 1 : -1, 'month');
        break;
    }
  }
  function getDateLabel() {
    var map = {
      MM: _$(showDate.value.get('month') + 1 + "\u6708"),
      YYYY: _$("{n}\u5E74", {
        n: showDate.value.get('year')
      })
    };
    var yearMonthFormat = _$('yearMonthFormat');
    if (yearMonthFormat === 'yearMonthFormat') {
      yearMonthFormat = 'YYYY MM';
    }
    var format = yearMonthFormat.split(' ');
    return _mapInstanceProperty(format).call(format, function (item) {
      return {
        value: map[item],
        onClick: function onClick(e) {
          e._ignore = true;
          instance.type.set(item === 'YYYY' ? 'year' : 'month');
        }
      };
    });
  }
  function setRelativeMonth(month) {
    showDate.set(showDate.value.add(month, 'month'));
  }
  function setRelativeYear(year) {
    showDate.set(showDate.value.add(year, 'year'));
  }
  function prevMonth() {
    setRelativeMonth(-1);
  }
  function nextMonth() {
    setRelativeMonth(1);
  }
  function prevYear() {
    setRelativeYear(-1);
  }
  function nextYear() {
    setRelativeYear(1);
  }
  function nextTenYears() {
    setRelativeYear(10);
  }
  function prevTenYears() {
    setRelativeYear(-10);
  }
  return {
    date: showDate,
    getDateLabel: getDateLabel,
    prevMonth: prevMonth,
    nextMonth: nextMonth,
    prevYear: prevYear,
    nextYear: nextYear,
    nextTenYears: nextTenYears,
    prevTenYears: prevTenYears
  };
}